import { HistoryTable } from "./HistoryTable";

export default HistoryTable;
